import { NgModule, ModuleWithProviders } from '@angular/core'
import { CommonModule } from '@angular/common'
import { IcosCard } from './card'


@NgModule({
  declarations: [IcosCard],
  exports: [IcosCard],
  imports: [CommonModule],
  entryComponents: [IcosCard],
})
export class IcosCardsModule {
  static forRoot(): ModuleWithProviders {
    return { ngModule: IcosCardsModule, providers: [] }
  }
}
